import React from 'react';
import PropTypes from 'prop-types';

import VivierPanel from '../../Vivier/components/VivierPanel';

// "Vivier" tab inside Cleaner/Show (plan 013 B2). All vivier data is keyed on
// the person's silae matricule, so we read it from the cleaner record.
const VivierTab = ({ record }) => {
  const silaeId = record && record.silae_id ? String(record.silae_id) : '';
  const sourceCleanerId = record && record.id ? String(record.id) : '';
  return (
    <VivierPanel
      silaeId={silaeId}
      sourceCleanerId={sourceCleanerId}
      showDocuments
    />
  );
};

VivierTab.propTypes = {
  record: PropTypes.object,
};

VivierTab.defaultProps = {
  record: {},
};

export default VivierTab;
